import React from 'react';
import PropTypes from 'prop-types';

const SeverityBreakdown = ({ breakdown }) => {
  // Check if there is any non-zero value
  const hasNonZeroValue =
    breakdown && Object.values(breakdown).some(value => value > 0);

  const severities = ['critical', 'high', 'medium', 'low', 'info'];

  // Function to get display value
  const getValue = (severity) => {
    if (!breakdown || !hasNonZeroValue) return '0';
    return breakdown[severity] || 0;
  };

  return (
    <div className="finding-severity-breakdown flex gap-2 w-full lg:w-auto">
      {severities.map((severity) => {
        const value = getValue(severity);

        // If all values are zero, use gray color
        const isAllZero = !hasNonZeroValue;
        const color = isAllZero ? '#C4C4C4' : '';
        const bgColor = isAllZero ? '#C4C4C41a' : '';

        return (
          <div
            key={severity}
            className={`severity-item severity-${severity}`}
            style={{
              color,
              borderColor: color,
              backgroundColor: bgColor,
              padding: '4px 8px',
              borderRadius: '4px',
              textAlign: 'center',
            }}
          >
            <span>{value}</span>
          </div>
        );
      })}
    </div>
  );
};

SeverityBreakdown.propTypes = {
  breakdown: PropTypes.shape({
    critical: PropTypes.number,
    high: PropTypes.number,
    medium: PropTypes.number,
    low: PropTypes.number,
    info: PropTypes.number
  })
};

export default SeverityBreakdown;
